import GuideBoard from 'components/GuideBoard/GuideBoard';
import { VideoIntro } from 'components/VideoIntro';
import { useState } from 'react';

export const Intro = () => {
  const [intro, setIntro] = useState('video');
  return (
    <>
      {intro === 'video' && <VideoIntro onVideoEnd={() => setIntro('guide')} />}
      {intro === 'guide' && <GuideBoard />}
    </>
  );
};
